import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardAdmin.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardAdmin.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardAdmin.vue?vue&type=script&lang=js&
// module id = 403
// module chunks = 0